export default __webpack_public_path__ + "static/media/guideicon.fd294c08.svg";